export function arrayLast<T>(array: Array<T>) {
	return array[array.length - 1];
}

export function range(size: number, startAt = 1) {
	return Array(size)
		.fill(0)
		.map((v, i) => i + startAt);
}

export function addOrRemove<T>(arr: Array<T>, el: T) {
	const newArr = [...(arr ?? [])];

	const idx = arr?.indexOf(el);
	if (idx >= 0) {
		newArr.splice(idx, 1);
	} else {
		newArr.push(el);
	}
	return newArr;
}

export function removeUndefined<T>(obj: T) {
	type Key = keyof typeof obj;
	const newObj = {...obj};
	Object.keys(newObj as object).forEach(
		(key) => (newObj[key as Key] === undefined || newObj[key as Key] === null) && delete newObj[key as Key],
	);
	return newObj;
}
